import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import generateGuid from "../../util/guid";
import Tooltip from "../common/Tooltip";
import * as types from "../../constants/ComponentConstants";
import * as Styles from "../../constants/StyleConstants";
import ValidationMessage from "../common/ValidationMessage";

const TextInput = (props) => {
	const hasValue = !!props.value;
	const hasValidationMessage = !!props.validationMessage;
	const validationMessageType = props.validationMessageType;
	const tooltiptype = props.tooltipType || types.TOOLTIP_INFO;
	const breakLineIfTooLong = props.breakLineIfTooLong;
	const value = props.value ? props.value : "";
	const sizeClassName = props.size ? "o-col-" + props.size : "o-col-12";
	const label = props.label + (props.optional ? " (Optioneel)" : "") + (props.maxLength && !breakLineIfTooLong ? (" (max. " + props.maxLength + " tekens)") : "");
	const errorLabel = (props.maxLength && breakLineIfTooLong ? (" (max. " + props.maxLength + " tekens)") : "");
	const info = props.tooltip ? <Tooltip isInput text={props.tooltip} tooltipType={tooltiptype} /> : null;
	const validation = props.validationMessage ? <ValidationMessage valdationMessage={props.validationMessage} type={validationMessageType} /> : null;
	const maxLength = props.maxLength ? props.maxLength : "";
	const disabled = props.disabled || props.readOnly;
	const id = generateGuid();
	let style = props.style ? props.style : {};
	style = props.hasLongLabelInRow ? Object.assign(style, { "padding-top": '35px', "padding-bottom": '0px' }) : style;
	const surroundingStyle = props.surroundingStyle;
	const isHighlighted = props.isHighlighted;
	const inputClassName = classnames({
		"c-input__field": true
	});
	const labelClassName = classnames({
		"c-input__label": true,
		"has-value": hasValue
	});

	const containerClassName = classnames({
		"c-input": true,
		"has-value": hasValue,
		"error": hasValidationMessage,
		"warning": hasValidationMessage && validationMessageType === types.ValidationMessageTypes.WARNING,
		"disabled": disabled
	});

	if (isHighlighted) {
		style = Styles.highlightedRowContainerStyle;
	}

	return (
		<div className={sizeClassName}>
			<div className={containerClassName} style={surroundingStyle}>
				<input
					id={id}
					style={style}
					value={value}
					disabled={disabled}
					onChange={props.onChange}
					className={inputClassName}
					maxLength={maxLength}
					name={props.name}
					autoComplete="new-street-address" />
				<label
					className={labelClassName}
					htmlFor={id}>
					{breakLineIfTooLong ?
						[label, <br />, errorLabel] :
						label}
				</label>
				{info}
			</div>
			{validation}
		</div>
	);
};

TextInput.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	value: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	maxLength: PropTypes.number,
	tooltip: PropTypes.string,
	tooltipType: PropTypes.string,
	validationMessage: PropTypes.string,
	validationMessageType: PropTypes.string,
	disabled: PropTypes.bool,
	readOnly: PropTypes.bool,
	size: PropTypes.number,
	optional: PropTypes.bool,
	style: PropTypes.object,
	surroundingStyle: PropTypes.object,
	isHighlighted: PropTypes.bool,
	hasLongLabelInRow: PropTypes.bool,
	breakLineIfTooLong: PropTypes.bool
};

TextInput.defaultProps = {
	isHighlighted: false
};

export default TextInput;
